import { UseIsMobile } from "common/hooks/UseIsMobile";
import { DesktopLogin } from "./desktop";
import { MobileLogin } from "./mobile";


const Login = () => {
    const mobile = UseIsMobile()

    return (
        <div>
            {
                mobile ?
                    <div className="md:hidden">
                        <MobileLogin />
                    </div>
                    :

                    <div className="hidden md:block">
                        <DesktopLogin />
                    </div>
            }
        </div>
    )
}


export default Login




